import { jsx as _jsx } from "react/jsx-runtime";
import { SDUIFlowLayoutRenderer } from "@faire/retailer-visitor-shared/components/SDUI/LayoutRenderers/FlowLayout/SDUIFlowLayoutRenderer";
import React from "react";
export var SDUILayoutRenderer = function(param) {
    var items = param.items, layout = param.layout;
    if (!layout) {
        return null;
    }
    if (!items || items.length === 0) {
        return null;
    }
    if (layout === null || layout === void 0 ? void 0 : layout.flow_layout) {
        return /*#__PURE__*/ _jsx(SDUIFlowLayoutRenderer, {
            items: items,
            flowLayout: layout.flow_layout
        });
    }
    return null;
};
